import { render, staticRenderFns } from "./ExamFeeRequestYearBatch.vue?vue&type=template&id=33bfd59a"
import script from "./ExamFeeRequestYearBatch.vue?vue&type=script&lang=js"
export * from "./ExamFeeRequestYearBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports